import { post } from "@/services/axiosUitils";
import { UserXirrResponse } from "@/utils/types/UserXirr";

const base = "/nps/cra/xirr/";

class UserXirrService {
  getUserXirr = async (
    quarter: string,
    financialYear: string
  ): Promise<UserXirrResponse> => {
    return await post<UserXirrResponse>(base, {
      quarter,
      financialYear,
    });
  };
}
const instance = new UserXirrService();
export default instance;
